(function() {
    'use strict';

    angular.module('elogbooks.admin.surveys', []);
})();
